import React, { useState, useRef } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentIcon from '@mui/icons-material/Payment';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SettingsIcon from '@mui/icons-material/Settings';
import LockIcon from '@mui/icons-material/Lock';
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import HistoryIcon from '@mui/icons-material/History'
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RedeemIcon from '@mui/icons-material/Redeem';
import LoyaltyIcon from '@mui/icons-material/Loyalty';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

 
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import { Done, KeyboardArrowUp } from '@mui/icons-material';




const View_Account = ({setAuthen, activeName, setActiveName, activeAvatar, setActiveAvatar, }) => {
  const [dropMenu, setdropMenu] = useState(null);
  const handleMenu = () => {
    setdropMenu(dropMenu === 'show' ? null : 'show');
  };

  const [activeFullName, setActiveFullName] = useState('John Alexander');  
  const menuItems = [
    { name: 'John Alexander', avatar: 'avatar1' },
    { name: 'Mary Shelley', avatar: 'avatar2' },
    { name: 'Amelia John', avatar: 'avatar3' },
    { name: 'George John', avatar: 'avatar4' }
  ];
  const handleItemClick = (name, avatar) => {
    setActiveFullName(name); // Extracting the first name
    setActiveName(name.split(' ')[0]); // Extracting the first name
    setActiveAvatar(avatar);
    handleMenu();
  };

  return (
    <> 
      <div className="flex-center small p-2 pe-0 bg-theme-green-3 justify-content-between">
            <span> 
              <img className='rounded-circle me-1 border border-white border-2 transition-1' src={`/img/${activeAvatar}.jpg`} width="40" height="40"/>
              <b>{activeFullName}!</b></span>
            <span className='small'>  
            <div className="dropdown">
              <Link onClick={handleMenu} class={`1dropdown-toggle p-3 pe-1 me-1 ${dropMenu} ${dropMenu==='show'&& 'bg-white'}`}>
              Shopping Profile 
              {!dropMenu && <KeyboardArrowDownIcon/>}
              {dropMenu==='show' && <KeyboardArrowUp/>}
              </Link>
              <ul className={`dropdown-menu p-0 mt-2 me-1 rounded-0 border border-theme-black-1 shadow shadow-lg ${dropMenu}`} style={{ right: '0' }}>
                {menuItems.map((item, index) => (
                  <li key={index} className='m-0 border-bottom'>
                    <Link
                      className={`dropdown-item py-2 px-3 small ${activeName === item.name.split(' ')[0] ? 'bg-theme-green-3 fw-bold' : 'hover-text-black hover-bg-black-1 transition-half'}`}
                      onClick={() => handleItemClick(item.name, item.avatar)}
                    >
                      <img className='rounded-circle me-1 border border-white border-2' src={`/img/${item.avatar}.jpg`} width="40" height="40" alt={item.name} />
                      {item.name}
                      {activeName === item.name.split(' ')[0] && <Done style={{ width: '15px', height: '15px' }} className='ms-2' />}
                    </Link>
                  </li>
                ))}
            </ul>               
            </div>         
            </span>
      </div>
    <div className='p-2'>
    <ul className="nav nav-pills flex-column mb-auto p-1">
  <li>
    <Link to="/shipping-address" className="nav-link link-body-emphasis">
      <LocationOnIcon />
      <span>Shipping Address</span>
    </Link>
  </li>
  <li>
    <Link className="nav-link link-body-emphasis">
      <PaymentIcon />
      <span>Payment Methods</span>
    </Link>
  </li>
  <hr className='mt-1 mb-1'/>
  <li>
    <Link to="/add-to-cart" className="nav-link link-body-emphasis">
      <ShoppingCartIcon />
      <span>View Cart</span>
    </Link>
  </li>
  <li>
    <Link to="/order-history" className="nav-link link-body-emphasis">
      <HistoryIcon />
      <span>View Order History</span>
    </Link>
  </li>
  <li>
    <Link to="/Favorites" className="nav-link link-body-emphasis">
      <FavoriteIcon />
      <span>View Favorites</span>
    </Link>
  </li>
  <hr className='mt-1 mb-1'/>
  <li>
  <Link   className="nav-link link-body-emphasis">
    <LocalOfferIcon />
    <span>Apply Voucher</span>
  </Link>
</li>
<li>
  <Link   className="nav-link link-body-emphasis">
    <RedeemIcon />
    <span>Buy Gift Voucher</span>
  </Link>
</li>
<li>
  <Link  className="nav-link link-body-emphasis">
    <LoyaltyIcon />
    <span>Royalty Points</span>
  </Link>
</li>
<hr className='mt-1 mb-1'/>
  <li>
    <Link   className="nav-link link-body-emphasis">
      <SettingsIcon />
      <span>Account Settings</span>
    </Link>
  </li>
  <li>
    <Link   className="nav-link link-body-emphasis">
      <LockIcon />
      <span>Change Password</span>
    </Link>
  </li>
  <li>
    <Link className="nav-link link-body-emphasis enabled">
      <ExitToAppIcon />
      <span onClick={() => setAuthen('anonymous')}>Sign Out</span>
    </Link>
  </li>
</ul>
</div>
    </>
  );
};

export default View_Account;